import InboxView from "@/components/InboxView/inboxView.component";
import BasePage from "@/infrastructure/BasePage/basePage.component";
import { Card } from "@/shadcn/components/ui/card";

const InboxPage = () => {
  return (
    <BasePage currPage="inbox">
      <Card className="flex flex-col w-full h-full rounded-sm dark:bg-background max-w-[100vw]">
        <InboxView />
      </Card>
    </BasePage>
  );
};

export default InboxPage;
